import { PropertyValueSet } from "@genesys/property";
import { PropertyDefinitions, SettingsCollection } from "../../../tools";
import { TopLevelOverrides } from "../../";
import { LoadDef } from "../../../main-content/load-types";
import { getDefaults } from "./create-defaults";
import { getInputsFromMoistureLoadItem } from "./get-inputs-from-existing-calculation-settings";
import { createInitialInputsFromDefaults } from "./get-inputs-from-defaults";
import * as SharedState from "../../../../shared-state";
import * as GraphQLTypes from "../../../../graphql-types";

export function getInitialInputs(
  moistureLoadItem: GraphQLTypes.MoistureLoadItemType,
  propertiesToKeep: Array<string>,
  productQuery: GraphQLTypes.MoistureLoadCalculationProductQuery,
  sharedState: SharedState.State,
  propertyDefinitions: PropertyDefinitions,
  climateDataFomMlSettings: PropertyValueSet.PropertyValueSet,
  moistureLoadUserSettings: PropertyValueSet.PropertyValueSet,
  allLoads: LoadDef[],
  properties: {
    readonly topLevelProperties: ReadonlyArray<string>;
    readonly topLevelOverridableProperties: ReadonlyArray<TopLevelOverrides>;
  }
): SettingsCollection {
  const moistureloadInput = moistureLoadItem.calculationSettings;
  const { topLevelProperties, topLevelOverridableProperties } = properties;

  if (moistureloadInput) {
    return getInputsFromMoistureLoadItem(
      moistureLoadItem,
      propertiesToKeep,
      topLevelProperties,
      topLevelOverridableProperties
    );
  }

  const defaults = getDefaults(
    productQuery,
    sharedState,
    propertyDefinitions,
    moistureLoadUserSettings,
    topLevelProperties,
    topLevelOverridableProperties
  );
  return createInitialInputsFromDefaults(
    defaults,
    productQuery.product.binDataLocations,
    climateDataFomMlSettings,
    allLoads,
    sharedState
  );
}
